import {Lang, PersonalityType} from '@context/CompetitionImamrezaContext';
import {useScopedTranslation} from '@hooks/useScopedTranslation';
import {loadLang} from '@utils/langStorage';
import React from 'react';
import arsr_ar_01 from './assets/images/artist/srv-ar-01.webp';

// Artist images
import arsr_en_01 from './assets/images/artist/srv-en-01.webp';
import arsr_fa_01 from './assets/images/artist/srv-fa-01.webp';
import insr_ar_01 from './assets/images/interaction/srv-ar-01.webp';
// Interaction images
import insr_en_01 from './assets/images/interaction/srv-en-01.webp';
import insr_fa_01 from './assets/images/interaction/srv-fa-01.webp';

import line from './assets/images/line.webp';
import linkIcon from './assets/images/link.webp';
import pcsr_ar_01 from './assets/images/peaceful/srv-ar-01.webp';
// Peaceful images
import pcsr_en_01 from './assets/images/peaceful/srv-en-01.webp';
import pcsr_fa_01 from './assets/images/peaceful/srv-fa-01.webp';
import srsr_ar_01 from './assets/images/searcher/srv-ar-01.webp';
// Searcher images
import srsr_en_01 from './assets/images/searcher/srv-en-01.webp';
import srsr_fa_01 from './assets/images/searcher/srv-fa-01.webp';
import svsr_ar_01 from './assets/images/servant/srv-ar-01.webp';
// Servant images
import svsr_en_01 from './assets/images/servant/srv-en-01.webp';
import svsr_fa_01 from './assets/images/servant/srv-fa-01.webp';

// Links for each personality type
const links: Record<PersonalityType, Record<number, string | null>> = {
	peaceful: {
		0: null,
		1: 'https://tv.razavi.ir/fa',
		2: 'https://museum.razavi.ir',
		3: null,
		4: null,
		5: 'https://khadem.razavi.ir/khedmat-dar-behesht',
		6: 'https://www.razavi.ir/fa/socialnetworks'
	},
	artist: {
		0: 'https://khademyar.razavi.ir',
		1: 'https://museum.razavi.ir',
		2: 'https://aqartshop.com',
		3: 'https://www.aqart.ir',
		4: 'https://www.razavi.ir/fa/socialnetworks'
	},
	interaction: {
		0: 'https://web.nasimrezvan.com/',
		1: 'https://khadem.razavi.ir/khedmat-dar-behesht',
		2: 'https://tv.razavi.ir/fa',
		3: null,
		4: null,
		5: 'https://www.razavi.ir/fa/socialnetworks'
	},
	servant: {
		0: 'https://khadem.razavi.ir/khedmat-dar-behesht',
		1: 'https://khademyar.razavi.ir',
		2: null,
		3: 'https://nazr.razavi.ir/pay',
		4: null,
		5: null,
		6: 'https://www.razavi.ir/fa/socialnetworks'
	},
	searcher: {
		0: 'https://library.razavi.ir',
		1: 'https://moshavere.razavi.ir/fa',
		2: 'https://razavi.ac.ir',
		3: 'https://museum.razavi.ir',
		4: 'https://khadem.razavi.ir/khedmat-dar-behesht',
		5: 'https://omran.razavi.ir',
		6: 'https://app.nasimrezvan.com/religious-questions-main',
		7: null,
		8: 'https://www.razavi.ir/fa/socialnetworks'
	}
};

// Image maps by personality type and language
const titleImages: Record<PersonalityType, Record<Lang, string>> = {
	peaceful: {
		en: pcsr_en_01,
		fa: pcsr_fa_01,
		ar: pcsr_ar_01
	},
	artist: {
		en: arsr_en_01,
		fa: arsr_fa_01,
		ar: arsr_ar_01
	},
	interaction: {
		en: insr_en_01,
		fa: insr_fa_01,
		ar: insr_ar_01
	},
	servant: {
		en: svsr_en_01,
		fa: svsr_fa_01,
		ar: svsr_ar_01
	},
	searcher: {
		en: srsr_en_01,
		fa: srsr_fa_01,
		ar: srsr_ar_01
	}
};

export const ServicesModeContent = ({type}: {type: PersonalityType}) => {
	const {t} = useScopedTranslation();
	const lang = loadLang() as Lang;
	
	const renderContent = (image: string, linkEntries: Record<number, string | null>, translationKey: string) => (
		<div className="w-full flex flex-col gap-y-10 font-aria word-spacing-normal">
			<div className="w-10/12 mx-auto flex flex-col gap-y-10">
				<img src={image} alt={type} className="w-full h-fit"/>
				<img src={line} alt="line" className="w-5/12 h-fit mx-auto"/>
				{Object.entries(linkEntries).map(([key, url]) => (
					<div key={key} className={`w-full flex items-center ${lang == 'en' ? 'flex-row-reverse' : 'flex-row'} justify-between gap-x-5`}>
						<div className={`w-full text-white ${lang == 'en' ? 'text-left' : 'text-right'} font-extrabold`}>
							{t(`services.${translationKey}.${key}`)}
						</div>
						{url && (
							<img
								src={linkIcon}
								alt="link"
								className="w-10 h-10 cursor-pointer"
								onClick={() => {
									window.open(url, '_blank'); // open in new tab
								}}
							/>
						)}
					</div>
				))}
			</div>
		</div>
	);
	
	if (!titleImages[type] || !titleImages[type][lang]) {
		return <div>No content available</div>;
	}
	
	return renderContent(titleImages[type][lang], links[type], type);
};
